import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { fetchData } from "../../Components/common/utils";
import { Spoiler } from '@mantine/core';

const Ebikes = () => {
  const [companyList, setCompanyList] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryDetail, setCategoryDetail] = useState({});
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/category/bike/e-bikes";
      const result = await fetchData(url);
      if (result && result.data) {
        setCompanyList(result.data)
        if (result.data.length !== 0) {
          setCategoryDetail(result.data[0]?.category)
          fetchProducts(result.data[0]?.category?.id)
        }
      }
      setLoading(false);
    };

    fetchApiData();
  }, []);
  const fetchProducts = async (id) => {
    const url = "api/search/category/product/" + id;
    const result = await fetchData(url);
    if (result) {
      console.log(result.data);

      setData(result.data);
    }
  };
  const handlesearch = (event) => {
    const filteredDatafdf = data.filter((item) =>
      [item.title, item.fuel_type, item.engine, item.transmission, item?.logo?.title]
        .some((field) =>
          field?.toLowerCase().includes(event.target.value.toLowerCase())
        )
    );
    if (event.target.value === '') {
      setFilteredData([]);
    } else {
      setFilteredData(filteredDatafdf);
    }

    setSearch(event.target.value)
  }
  return (
    <>
      <section className=" buy mt-1 mb-1 py-5">
        <div className="container">
          {/* <h1 className="text-center mb-5">E Bikes</h1> */}
          {loading ? (
            <>
              <div className=" text-center logo mt-4">
                {Array.from({ length: 6 }).map((_, i) => (
                  <img key={i} className="skeleton m-2" />
                ))}
              </div>
            </>
          ) : (
            <>
              <Spoiler
                showLabel="Show more"
                maxHeight={200}
                hideLabel="Hide details"
                expanded={expanded}
                onExpandedChange={setExpanded}
                styles={{
                  control: {
                    display: "flex",
                    justifyContent: "flex-end", // pushes button to right
                    width: "100%",
                  },
                }}
              >
                <div class="content-box-2 mb-4 text-white">
                  <div class="content-body"
                    dangerouslySetInnerHTML={{ __html: categoryDetail.long_description }}>
                  </div>
                </div>

              </Spoiler>
              <h2 className="fw-bold text-center  mb-3">Find Product</h2>
              <input placeholder="Search by title, fuel type or transmission..." value={search} onChange={handlesearch} type="text" className="form-control" />
              <div className="row mt-3">
                {filteredData.map((details, index) => (
                  <div className="col-md-3 mb-3" key={index}>
                    <NavLink
                      to={
                        details.varient
                          ? `${details?.logo?.title}/${details.slug}`
                          : `${details?.logo?.title}/${'detail'}/${details.slug}`
                      }
                    >
                      <div className="card h-100">
                        <div className="card-img-wrapper">
                          <img
                            className="latest-product-img"
                            src={details.media[0].url}
                            alt={details.title}
                          />
                        </div>
                        <div className="card-body text-center">
                          <h6 className="card-title text-center">
                            {details.title}
                          </h6>
                          <strong className="dollar">
                            {details.price_start}{" "}
                            {details.price_end === null
                              ? ""
                              : "-" + details.price_end}
                          </strong>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                ))}
              </div>
              <h2 className="fw-bold text-center mt-3 mb-5">Company List</h2>
              <div className="d-flex logo align-items-center justify-content-center gap-5 flex-wrap">
                {companyList.map((details, index) => (
                  <div
                    className="d-flex flex-column align-items-center justify-content-center gap-2"
                    key={index}
                  >
                    <Link
                      to={`/e-bikes/${details.slug}`}>
                      <img
                        src={details?.media[0]?.original_url}
                        alt={`${details.title} logo`}
                      />
                    </Link>
                    <p>{details.title}</p>
                  </div>
                ))}

              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default Ebikes;
